export const initialVaultTransactionsTable = {
    data: { items: [], totalElements: 0, page: 0, size: 20, totalPages: 0 },
    loading: false,
};

export const initialRecipientsDrillDown = {
    data: [],
    loading: false,
    state: null, // read | unread | signed | unsigned
};
